import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "./App.css";
import { Footer } from "./components/Footer";
import Header from "./components/Header";
import CheckOutPage from "./pages/CheckOutPage/CheckOutPage";
import HomePage from "./pages/HomePage/HomePage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import ResultPage from "./pages/ResultPage/ResultPage";
import TestPage from "./pages/TestPage/TestPage";
import PaymentCompletePage from "./pages/Payments/PaymentCompletePage";
import PaymentCancelPage from "./pages/Payments/PaymentCancelPage";
import CompletePage from "./pages/CompletePage/CompletePage";

const App: React.FC = () => {
  return (
    <Router>
      <div className="App flex flex-col min-h-screen">
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          theme="colored"
        />
        <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/test" element={<TestPage />} />
            <Route path="/checkout" element={<CheckOutPage />} />
            <Route path="/result" element={<ResultPage />} />
            {/* TODO: Add rules to go to this pages */}
            <Route path="/payment/complete" element={<PaymentCompletePage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
